import Api from './Api'
import Model from './interface/Model'

export default class CompanyContact extends Model {
  public api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'company_contacts' as string | null,
      plural: 'company_contacts' as string | null,
    },
  }

  public id: string | null = null

  public first_name: string = ''

  public last_name: string = ''

  public salutation: any = null

  public email: string = ''

  public title: string = ''

  public company_id: string | null = null

  public owner_id: string | null = null

  public source: string = 'other'

  public status: string = ''

  public verified_at: string | null = null

  public get name() {
    return `${this.first_name} ${this.last_name}`
  }

  public contacts: any = [
    {
      label: 'Phone',
      value: '',
    },
  ]

  public address: any = {
    line_1: '',
    line_2: '',
    line_3: '',
    line_4: '',
  }

  public email_opt_out: boolean = false

  public archived_at: string | null = null

  public get status_color(): string {
    if (this.status === 'active') {
      return 'primary'
    }
    if (this.status === 'system_inactive') {
      return 'danger'
    }
    return 'warning'
  }

  public get apiData() {
    return {
      id: this.id,
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      title: this.title,
      company_id: this.company_id,
      contacts: this.contacts,
      address: this.address,
      email_opt_out: this.email_opt_out,
      owner_id: this.owner_id,
      salutation: this.salutation,
      archived_at: this.archived_at,
      status: this.status,
      source: this.source,
    }
  }

  public static async getContacts(ids: string[]) {
    let api = new Api()
    return api
      .get('company_contacts/search_ids', { ids })
      .then(response => response)
      .catch(error => error)
  }

  public static salutations = [
    {
      name: 'Mr.',
      value: 'mr',
    },
    {
      name: 'Ms.',
      value: 'ms',
    },
    {
      name: 'Mrs.',
      value: 'mrs',
    },
    {
      name: 'Dr.',
      value: 'dr',
    },
    {
      name: 'None',
      value: null,
    },
  ]

  public static contact_status_list: any[] = [
    {
      name: 'Active',
      value: 'active',
    },
    {
      name: 'Contact Info Not Accurate',
      value: 'contact_info_not_accurate',
    },
    {
      name: 'Follow Up in 6 Months',
      value: 'follow_up_in_6_months',
    },
    {
      name: 'Follow Up in 12 Months',
      value: 'follow_up_in_12_months',
    },
    {
      name: 'Not Interested',
      value: 'not_interested',
    },
    {
      name: 'Left Company',
      value: 'left_company',
    },
    {
      name: 'Extend Active Status',
      value: 'extend_validation',
    },
    {
      name: 'System Inactive',
      value: 'system_inactive',
    },
  ]

  public static origin_status_list: any[] = [
    {
      name: 'Other',
      value: 'other',
    },
    // { (make inactive but may need in the future)
    //   name: 'Referral',
    //   value: 'referral',
    // },
    {
      name: 'Inside Sales Sourced',
      value: 'inside_sales_sourced',
    },
    {
      name: 'Conferences/Tradeshows',
      value: 'conferences_tradeshows',
    },
    {
      name: 'Existing Relationship',
      value: 'existing_relationship',
    },
    {
      name: 'LinkedIn Sales Navigator',
      value: 'linkedin_sales_navigator',
    },
    {
      name: 'Marketing Website Contact Us',
      value: 'marketing_website_contact_us',
    },
    {
      name: 'Paid Advertising',
      value: 'paid_advertising',
    },
    {
      name: 'SellerCrowd',
      value: 'sellercrowd',
    },
    {
      name: 'Social Media',
      value: 'social_media',
    },
    {
      name: 'SponsorUnited',
      value: 'sponsor_united',
    },
    {
      name: 'Web Search',
      value: 'web_search',
    },
    {
      name: 'Winmo',
      value: 'winmo',
    },
  ]
}
